import { render, staticRenderFns } from "./CorpDataSettings.vue?vue&type=template&id=5ebcc954&scoped=true&"
import script from "./CorpDataSettings.vue?vue&type=script&lang=js&"
export * from "./CorpDataSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebcc954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
